import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import { stringInputSpec } from '../../lib/editing-configs';

const RentersInsuranceEntryPointWrapper = ({
  buttonAnnotation,
  buttonText,
  defaultZipCode,
  heading,
  pricingCode,
  subheading,
}) => {
  return (
    <StructuredContent>
      {{
        type: 'RentersInsuranceEntryPoint',
        version: '1.0.0',
        props: {
          buttonAnnotation,
          buttonText,
          defaultZipCode,
          heading,
          pricingCode,
          subheading,
        },
      }}
    </StructuredContent>
  );
};

RentersInsuranceEntryPointWrapper.propTypes = {
  /** Legal disclaimer displayed below the CTA */
  buttonAnnotation: PropTypes.string,
  /** Text on the CTA */
  buttonText: PropTypes.string,
  /** Default zipcode on first render */
  defaultZipCode: PropTypes.string,
  /** Heading text */
  heading: PropTypes.string,
  /** Partner's SRC code */
  pricingCode: PropTypes.string,
  /** Body text */
  subheading: PropTypes.string,
};

RentersInsuranceEntryPointWrapper.defaultProps = {
  buttonAnnotation: 'With bolt agency',
  buttonText: 'COMPARE QUOTES',
  defaultZipCode: '94103',
  heading: "Compare quotes and save on renter's insurance",
  pricingCode: '',
  subheading:
    'Answer a few short questions to see the insurers that best match you - it pays to compare.',
};

RentersInsuranceEntryPointWrapper.getEditingConfig = () => {
  return [
    stringInputSpec('buttonAnnotation', 'Button Annotation'),
    stringInputSpec('buttonText', 'Button Text'),
    stringInputSpec('defaultZipCode', 'Default Zip Code'),
    stringInputSpec('heading', 'Heading'),
    stringInputSpec('pricingCode', 'Pricing Code'),
    stringInputSpec('subheading', 'Subheading'),
  ];
};

RentersInsuranceEntryPointWrapper.displayName =
  'RentersInsuranceEntryPointWrapper';

export default RentersInsuranceEntryPointWrapper;
